import React from "react";

export default function PaperPlaneTilt() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.2812 4.48482L2.99026 11.0541C2.79432 11.1093 2.61991 11.2231 2.49035 11.3801C2.36079 11.5372 2.28225 11.73 2.26522 11.9329C2.2482 12.1358 2.2935 12.339 2.39507 12.5154C2.49664 12.6919 2.64965 12.8331 2.83363 12.9203L13.535 17.9893C13.7437 18.0882 13.9118 18.2562 14.0106 18.465L19.0797 29.1663C19.1669 29.3503 19.3081 29.5033 19.4845 29.6049C19.661 29.7065 19.8642 29.7518 20.0671 29.7347C20.2699 29.7177 20.4628 29.6392 20.6198 29.5096C20.7769 29.38 20.8906 29.2056 20.9459 29.0097L27.5151 5.71873C27.5634 5.54764 27.5652 5.36678 27.5203 5.19478C27.4754 5.02278 27.3855 4.86585 27.2598 4.74016C27.1341 4.61446 26.9772 4.52455 26.8052 4.47966C26.6332 4.43478 26.4523 4.43656 26.2812 4.48482Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8579 18.1422L19.5148 12.4854"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
